import { component } from "picoapp";

export const readMore = component((node) => {
  const readMoreButton = node.querySelector(".read-more-button");
  const readLessButton = node.querySelector(".read-less-button");
  const readMoreTextContainer = node.querySelector(".read-more-text-container");
  const accordionContentWrapper = node.closest(".js-accordion-content-wrapper");
  const accordionContent = node.closest(".js-accordion-content");
  const maxLines = node.dataset.maxLines;

  const resetClamp = () => {
    if (
      !(
        readMoreTextContainer.offsetHeight <
          readMoreTextContainer.scrollHeight ||
        readMoreTextContainer.offsetWidth < readMoreTextContainer.scrollWidth
      )
    ) {
      readMoreButton.classList.add("hidden");
    } else {
      readMoreButton.classList.remove("hidden");
    }
  };

  resetClamp();

  const resetAccordionHeight = () => {
    if (!accordionContentWrapper) return;
    accordionContentWrapper.style.height = `${accordionContent.offsetHeight}px`;
  };

  const handleReadMoreButtonClick = function (e) {
    e.preventDefault();

    readMoreTextContainer.classList.remove(`line-clamp-${maxLines}`);
    readMoreButton.classList.add("hidden");
    readLessButton.classList.remove("hidden");
    resetAccordionHeight();
  };

  const handleReadLessButtonClick = function (e) {
    e.preventDefault();

    readMoreTextContainer.classList.add(`line-clamp-${maxLines}`);
    readLessButton.classList.add("hidden");
    readMoreButton.classList.remove("hidden");
    resetAccordionHeight();
  };

  readMoreButton.addEventListener("click", handleReadMoreButtonClick);
  readLessButton.addEventListener("click", handleReadLessButtonClick);

  const ro = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target === readMoreTextContainer) {
        resetClamp();
      }
    }
  });

  ro.observe(readMoreTextContainer);

  return () => {
    readMoreButton.removeEventListener("click", handleReadMoreButtonClick);
    readLessButton.removeEventListener("click", handleReadLessButtonClick);
    ro.disconnect();
  };
});
